export default "__VITE_ASSET__Cx_5TMaE__"